import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function ChevronRightRounded({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <ChevronRightRounded.Outline {...props} />
  ) : (
    <ChevronRightRounded.Solid {...props} />
  );
}

ChevronRightRounded.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

ChevronRightRounded.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M8.02843 12.9395C7.73491 13.2317 7.73388 13.7066 8.02614 14.0001C8.31841 14.2937 8.79328 14.2947 9.0868 14.0024L12.5728 10.5314C12.7142 10.3907 12.7936 10.1994 12.7936 9.99995C12.7936 9.80047 12.7142 9.60922 12.5728 9.46848L9.0868 5.99747C8.79328 5.70521 8.31841 5.70624 8.02614 5.99976C7.73388 6.29329 7.73491 6.76816 8.02843 7.06042L10.9807 9.99995L8.02843 12.9395Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 9.99976C0 15.523 4.47784 19.9998 10 19.9998C15.5222 19.9998 20 15.523 20 9.99976C20 4.47754 15.5222 -0.000244141 10 -0.000244141C4.47779 -0.000244141 0 4.47754 0 9.99976ZM10 18.4998C5.30616 18.4998 1.5 14.6945 1.5 9.99976C1.5 5.30597 5.30621 1.49976 10 1.49976C14.6938 1.49976 18.5 5.30597 18.5 9.99976C18.5 14.6945 14.6938 18.4998 10 18.4998Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
